export default {
    getInstance(window) {
        return {
            getQueryParam(queryParamName) {
                const params = new URLSearchParams(window.location.search);

                return params.get(queryParamName);
            },
            setQueryParams(queryParams) {
                const stringifiedQueryParams = new URLSearchParams(queryParams).toString();

                window.history.replaceState("", "", "?" + stringifiedQueryParams);
            },
            setQueryParam(queryParamName, value) {
                const params = new URLSearchParams(window.location.search);

                if (!!value) {
                    params.set(queryParamName, value);
                } else {
                    params.delete(queryParamName);
                }

                const stringifiedQueryParams = params.toString();
                const state = "?" + stringifiedQueryParams;

                window.history.replaceState("", "", state);
            },
        };
    },
};
